<script setup>
// Renderiza a mensagem de LISTA (menu) enviada pelo atendente via AstraCall.
// Formato do content (gerado no send_rich):
//   "📋 <texto>\n_<texto do botão>_\n*Seção*?\n▫️ Item — descrição\n▫️ Item"
// Detecção/roteamento no Message.vue (marcador 📋 no início). Só exibição.
import { computed } from 'vue';
import { useMessageContext } from '../provider.js';
import BaseBubble from 'next/message/bubbles/Base.vue';

const { content } = useMessageContext();

const parsed = computed(() => {
  const raw = String(content?.value || '');
  const lines = raw.split('\n').map(l => l.trim()).filter(Boolean);
  const body = (lines[0] || '').replace(/^\u{1F4CB}\s*/u, '').trim();
  // texto do botão = linha em _itálico_ (se houver)
  const btnLine = lines.find(l => /^_.+_$/.test(l));
  const buttonText = btnLine ? btnLine.replace(/^_|_$/g, '').trim() : '';
  // itens = linhas com marcador ▫️/- ; seções em *negrito* viram cabeçalho
  const rows = [];
  lines.forEach(l => {
    if (/^\*.+\*$/.test(l)) {
      rows.push({ section: l.replace(/^\*|\*$/g, '').trim() });
    } else if (/^[▫◾\-•]️?\s+/u.test(l)) {
      rows.push({ label: l.replace(/^[▫◾\-•]️?\s+/u, '').trim() });
    }
  });
  return { body, buttonText, rows };
});
</script>

<template>
  <BaseBubble
    class="!p-3.5 !max-w-[300px] min-w-[220px]"
    data-bubble-name="interactive-list"
    hide-meta
  >
    <div class="flex flex-col gap-2.5">
      <div class="font-medium leading-snug whitespace-pre-line text-n-slate-12">
        {{ parsed.body }}
      </div>
      <div class="flex flex-col divide-y rounded-lg divide-n-weak outline outline-1 outline-n-weak">
        <template v-for="(r, i) in parsed.rows" :key="i">
          <div
            v-if="r.section"
            class="px-3 py-1.5 text-[0.6875rem] font-medium uppercase tracking-wide text-n-slate-10 bg-n-alpha-1"
          >
            {{ r.section }}
          </div>
          <div v-else class="px-3 py-2 text-sm text-n-slate-12">{{ r.label }}</div>
        </template>
      </div>
      <div
        v-if="parsed.buttonText"
        class="flex items-center justify-center gap-1.5 px-3 py-2 text-sm rounded-lg bg-n-alpha-1 text-n-brand"
      >
        <span class="i-lucide-list size-4" />
        {{ parsed.buttonText }}
      </div>
    </div>
  </BaseBubble>
</template>
